<script setup lang="ts">
</script>

<template>
    <aeg-icon icon="pi pi-envelope" />
</template>

<style scoped lang="scss">
</style>
